var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"d-flex flex-column align-items-center justify-content-center mx-0 px-0 root-layout",attrs:{"fluid":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }